import { render, staticRenderFns } from "./ValuerProfileIndex.vue?vue&type=template&id=28f3a36d&scoped=true&"
import script from "./ValuerProfileIndex.vue?vue&type=script&lang=ts&"
export * from "./ValuerProfileIndex.vue?vue&type=script&lang=ts&"
import style0 from "./ValuerProfileIndex.vue?vue&type=style&index=0&id=28f3a36d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3a36d",
  null
  
)

export default component.exports